// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* HistorialUser.module.css */

/* ══ Layout general ══ */
.HistorialUser_panelPage__GVCWR {
  display: flex;
  min-height: 100vh;
  background: #f0f4f8;
}

/* ══════════════════════════════════════
   SIDEBAR
══════════════════════════════════════ */
.HistorialUser_sidebar__cCMHJ {
  width: 220px;
  min-width: 220px;
  background: #1a3a5c;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 28px 0 20px;
  position: sticky;
  top: 0;
  height: 100vh;
  overflow-y: auto;
}

.HistorialUser_sidebarTop__DunvU {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 20px 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  margin-bottom: 8px;
}

.HistorialUser_avatar__oCdVh {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #2db899;
  color: #fff;
  font-size: 1.2rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
  flex-shrink: 0;
}

.HistorialUser_avatarImg__BZeA4 {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  object-fit: cover;
  margin-bottom: 12px;
}

.HistorialUser_userName__Qt-gG {
  font-size: 14px;
  font-weight: 700;
  color: #fff;
  text-align: center;
  margin-bottom: 2px;
}

.HistorialUser_userEmail__4a5bn {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.55);
  text-align: center;
  margin-bottom: 12px;
  word-break: break-all;
}

.HistorialUser_lastConsult__j5bX6 {
  background: rgba(45, 184, 153, 0.2);
  border: 1px solid rgba(45, 184, 153, 0.4);
  border-radius: 999px;
  padding: 4px 10px;
  font-size: 10px;
  color: #2db899;
  font-weight: 600;
  text-align: center;
}

/* Menú */
.HistorialUser_menuLabel__LdpbD {
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.35);
  padding: 0 20px;
  margin-bottom: 6px;
  margin-top: 4px;
}

.HistorialUser_menuList__UGA3Z {
  list-style: none;
  padding: 0;
  margin: 0;
  flex: 1 1;
}

.HistorialUser_menuItem__W4Yhg {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 11px 20px;
  font-size: 14px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.7);
  cursor: pointer;
  border-left: 3px solid transparent;
  text-decoration: none;
  transition:
    background 0.15s,
    color 0.15s;
}

.HistorialUser_menuItem__W4Yhg:hover {
  background: rgba(255, 255, 255, 0.07);
  color: #fff;
}

.HistorialUser_menuItemActive__WCR1T {
  background: rgba(45, 184, 153, 0.15);
  border-left-color: #2db899;
  color: #fff;
  font-weight: 600;
}

/* Botón cerrar sesión */
.HistorialUser_sidebarBottom__2lV1a {
  padding: 20px;
}

.HistorialUser_btnLogout__-EIND {
  width: 100%;
  padding: 10px;
  background: transparent;
  border: 1.5px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.6);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition:
    border-color 0.2s,
    color 0.2s;
}

.HistorialUser_btnLogout__-EIND:hover {
  border-color: #fda29b;
  color: #fda29b;
}

/* ══════════════════════════════════════
   CONTENIDO PRINCIPAL
══════════════════════════════════════ */
.HistorialUser_main__aFyga {
  flex: 1 1;
  padding: 32px 28px;
  overflow-y: auto;
}

/* Cabecera del panel */
.HistorialUser_mainHeader__cDtxE {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
}

.HistorialUser_mainHeaderLeft__zefgY p {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #2db899;
  margin-bottom: 2px;
}

.HistorialUser_mainHeaderLeft__zefgY h1 {
  font-size: 1.8rem;
  font-weight: 800;
  color: #1a3a5c;
  margin: 0;
}

.HistorialUser_mainHeaderRight__h9SRO {
  display: flex;
  align-items: center;
  gap: 14px;
}

.HistorialUser_bellBtn__sI7qf {
  background: #fff;
  border: 1.5px solid #e4e7ec;
  border-radius: 50%;
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #667085;
}

.HistorialUser_headerAvatar__bZIxO {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: #2db899;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* ══ Banner bienvenida ══ */
.HistorialUser_welcomeBanner__Jr1D\\+ {
  background: linear-gradient(135deg, #1a3a5c 0%, #1a6b5c 100%);
  border-radius: 14px;
  padding: 24px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.HistorialUser_welcomeLeft__D8nz\\+ {
  display: flex;
  align-items: center;
  gap: 16px;
}

.HistorialUser_welcomeAvatar__Ep5v4 {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: rgba(45, 184, 153, 0.35);
  color: #fff;
  font-size: 1rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.HistorialUser_welcomeEyebrow__2-uzX {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 4px;
}

.HistorialUser_welcomeName__8Kmdk {
  font-size: 1.3rem;
  font-weight: 800;
  color: #fff;
  margin-bottom: 2px;
}

.HistorialUser_welcomeDate__g03zU {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.55);
}

.HistorialUser_welcomeRight__lKxk- {
  text-align: right;
}

.HistorialUser_profileLabel__Q4ktL {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 6px;
}

.HistorialUser_profileBar__p7aiR {
  width: 160px;
  height: 6px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 99px;
  overflow: hidden;
  margin-bottom: 6px;
}

.HistorialUser_profileBarFill__-qoAF {
  height: 100%;
  background: #2db899;
  border-radius: 99px;
}

.HistorialUser_profileLink__0kNKN {
  font-size: 11px;
  color: #2db899;
  text-decoration: none;
  font-weight: 600;
}

.HistorialUser_profileLink__0kNKN:hover {
  text-decoration: underline;
}

/* ══ Stats row ══ */
.HistorialUser_statsGrid__g97fW {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
  margin-bottom: 20px;
}

.HistorialUser_statCard__DwkU0 {
  background: #fff;
  border-radius: 12px;
  padding: 20px 20px 16px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06);
}

.HistorialUser_statValue__4Zmp8 {
  font-size: 1.8rem;
  font-weight: 800;
  color: #1a3a5c;
  line-height: 1;
  margin-bottom: 4px;
}

.HistorialUser_statValue__4Zmp8.HistorialUser_teal__x66n6 {
  color: #2db899;
}
.HistorialUser_statValue__4Zmp8.HistorialUser_orange__1N8vH {
  color: #f59e0b;
}

.HistorialUser_statTitle__aJXnK {
  font-size: 13px;
  font-weight: 600;
  color: #344054;
  margin-bottom: 2px;
}

.HistorialUser_statSub__HWQVt {
  font-size: 11px;
  color: #98a2b3;
}

/* ══ Dos columnas ══ */
.HistorialUser_twoCol__2Fwpg {
  display: grid;
  grid-template-columns: 1fr 300px;
  gap: 16px;
  margin-bottom: 16px;
}

/* ══ Cards genéricas ══ */
.HistorialUser_card__m-zP3 {
  background: #fff;
  border-radius: 14px;
  padding: 22px 22px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06);
}

.HistorialUser_cardHeader__oaPpr {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.HistorialUser_cardTitle__Fa4wp {
  font-size: 15px;
  font-weight: 700;
  color: #1a3a5c;
  margin: 0;
}

.HistorialUser_cardLink__\\+6Spp {
  font-size: 12px;
  color: #2db899;
  font-weight: 600;
  text-decoration: none;
}

.HistorialUser_cardLink__\\+6Spp:hover {
  text-decoration: underline;
}

/* ══ Cita card ══ */
.HistorialUser_citaItem__g3jcv {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px 0;
  border-bottom: 1px solid #f2f4f7;
}

.HistorialUser_citaItem__g3jcv:last-child {
  border-bottom: none;
}

.HistorialUser_citaAvatar__TqldI {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #e6f7f3;
  color: #2db899;
  font-size: 12px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.HistorialUser_citaInfo__VAlKZ {
  flex: 1 1;
}

.HistorialUser_citaEspecialidad__0GiI2 {
  font-size: 14px;
  font-weight: 700;
  color: #344054;
  margin-bottom: 2px;
}

.HistorialUser_citaDoctor__rLhfJ {
  font-size: 12px;
  color: #667085;
  margin-bottom: 3px;
}

.HistorialUser_citaFecha__xBFso {
  font-size: 12px;
  color: #98a2b3;
}

.HistorialUser_citaMeta__U7eTM {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
}

.HistorialUser_badgeTele__2XjqO {
  background: #e6f7f3;
  color: #2db899;
  font-size: 10px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 999px;
}

.HistorialUser_badgeDomicilio__HVuq- {
  background: #fff8ec;
  color: #d97706;
  font-size: 10px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 999px;
}

.HistorialUser_badgePresencial__QPoGD {
  background: #eff8ff;
  color: #1a6bcc;
  font-size: 10px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 999px;
}

.HistorialUser_badgeConfirmada__e3njO {
  background: #e6f7f3;
  color: #2db899;
  font-size: 10px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 999px;
}

.HistorialUser_badgePendiente__Ix1d4 {
  background: #fff8ec;
  color: #d97706;
  font-size: 10px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 999px;
}

.HistorialUser_cancelLink__4k1KM {
  font-size: 11px;
  color: #98a2b3;
  text-decoration: none;
  cursor: pointer;
}

.HistorialUser_cancelLink__4k1KM:hover {
  color: #d92d20;
}

.HistorialUser_emptyState__kmfAv {
  text-align: center;
  padding: 24px 0;
  color: #98a2b3;
  font-size: 14px;
}

/* ══ Acciones rápidas ══ */
.HistorialUser_quickActions__Ng2x\\+ {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.HistorialUser_quickAction__BIMVr {
  display: flex;
  flex-direction: column;
  padding: 12px 14px;
  border-radius: 10px;
  border: 1.5px solid #e4e7ec;
  cursor: pointer;
  text-decoration: none;
  transition:
    border-color 0.15s,
    background 0.15s;
  background: #fff;
}

.HistorialUser_quickAction__BIMVr:hover {
  border-color: #2db899;
  background: #f0fdf9;
}

.HistorialUser_quickActionPrimary__kILpF {
  border-color: #2db899;
  background: #f0fdf9;
}

.HistorialUser_quickActionTitle__2DNaJ {
  font-size: 13px;
  font-weight: 700;
  color: #1a3a5c;
  margin-bottom: 2px;
}

.HistorialUser_quickActionPrimary__kILpF .HistorialUser_quickActionTitle__2DNaJ {
  color: #2db899;
}

.HistorialUser_quickActionSub__rfTgK {
  font-size: 11px;
  color: #98a2b3;
}

/* ══ Tabla actividad reciente ══ */
.HistorialUser_table__6zJXl {
  width: 100%;
  border-collapse: collapse;
}

.HistorialUser_table__6zJXl thead tr th {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  color: #98a2b3;
  padding: 0 10px 12px 0;
  text-align: left;
  border-bottom: 1px solid #f2f4f7;
}

.HistorialUser_table__6zJXl tbody tr td {
  font-size: 13px;
  color: #344054;
  padding: 12px 10px 12px 0;
  border-bottom: 1px solid #f2f4f7;
  vertical-align: middle;
}

.HistorialUser_table__6zJXl tbody tr:last-child td {
  border-bottom: none;
}

.HistorialUser_badgeCompletada__GFkor {
  background: #e6f7f3;
  color: #2db899;
  font-size: 10px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 999px;
  white-space: nowrap;
}

.HistorialUser_badgeCancelada__gnOwf {
  background: #fff1f0;
  color: #d92d20;
  font-size: 10px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 999px;
  white-space: nowrap;
}

/* ══ Dependientes ══ */
.HistorialUser_dependientesGrid__h3F25 {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 12px;
}

.HistorialUser_dependienteCard__gG4TL {
  border: 1.5px solid #e4e7ec;
  border-radius: 10px;
  padding: 14px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.HistorialUser_depAvatar__IaUAD {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #1a3a5c;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.HistorialUser_depName__YqCwl {
  font-size: 13px;
  font-weight: 700;
  color: #344054;
  margin-bottom: 2px;
}

.HistorialUser_depMeta__lETFU {
  font-size: 11px;
  color: #98a2b3;
}

.HistorialUser_btnAddDep__MOhlo {
  border: 1.5px dashed #d0d5dd;
  border-radius: 10px;
  padding: 14px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #2db899;
  cursor: pointer;
  background: transparent;
  text-decoration: none;
  transition: border-color 0.15s;
}

.HistorialUser_btnAddDep__MOhlo:hover {
  border-color: #2db899;
  background: #f0fdf9;
}

/* ══ Responsive ══ */
@media (max-width: 900px) {
  .HistorialUser_sidebar__cCMHJ {
    display: none;
  }
  .HistorialUser_statsGrid__g97fW {
    grid-template-columns: repeat(2, 1fr);
  }
  .HistorialUser_twoCol__2Fwpg {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .HistorialUser_statsGrid__g97fW {
    grid-template-columns: 1fr 1fr;
  }
  .HistorialUser_main__aFyga {
    padding: 20px 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/HistorialUser/HistorialUser.module.css"],"names":[],"mappings":"AAAA,6BAA6B;;AAE7B,yBAAyB;AACzB;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;wCAEwC;AACxC;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,oBAAoB;EACpB,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,iDAAiD;EACjD,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,SAAS;AACT;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,kCAAkC;EAClC,qBAAqB;EACrB;;eAEa;AACf;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,WAAW;EACX,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,4CAA4C;EAC5C,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf;;cAEY;AACd;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;wCAEwC;AACxC;EACE,SAAO;EACP,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,4BAA4B;AAC5B;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,qBAAqB;EACrB;;oBAEkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,mCAAmC;AACnC;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE;IACE,aAAa;EACf;EACA;IACE,qCAAqC;EACvC;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;EACA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["/* HistorialUser.module.css */\n\n/* ══ Layout general ══ */\n.panelPage {\n  display: flex;\n  min-height: 100vh;\n  background: #f0f4f8;\n}\n\n/* ══════════════════════════════════════\n   SIDEBAR\n══════════════════════════════════════ */\n.sidebar {\n  width: 220px;\n  min-width: 220px;\n  background: #1a3a5c;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 28px 0 20px;\n  position: sticky;\n  top: 0;\n  height: 100vh;\n  overflow-y: auto;\n}\n\n.sidebarTop {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 0 20px 24px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  margin-bottom: 8px;\n}\n\n.avatar {\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  background: #2db899;\n  color: #fff;\n  font-size: 1.2rem;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 12px;\n  flex-shrink: 0;\n}\n\n.avatarImg {\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  object-fit: cover;\n  margin-bottom: 12px;\n}\n\n.userName {\n  font-size: 14px;\n  font-weight: 700;\n  color: #fff;\n  text-align: center;\n  margin-bottom: 2px;\n}\n\n.userEmail {\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.55);\n  text-align: center;\n  margin-bottom: 12px;\n  word-break: break-all;\n}\n\n.lastConsult {\n  background: rgba(45, 184, 153, 0.2);\n  border: 1px solid rgba(45, 184, 153, 0.4);\n  border-radius: 999px;\n  padding: 4px 10px;\n  font-size: 10px;\n  color: #2db899;\n  font-weight: 600;\n  text-align: center;\n}\n\n/* Menú */\n.menuLabel {\n  font-size: 9px;\n  font-weight: 700;\n  letter-spacing: 1.2px;\n  text-transform: uppercase;\n  color: rgba(255, 255, 255, 0.35);\n  padding: 0 20px;\n  margin-bottom: 6px;\n  margin-top: 4px;\n}\n\n.menuList {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  flex: 1;\n}\n\n.menuItem {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 11px 20px;\n  font-size: 14px;\n  font-weight: 500;\n  color: rgba(255, 255, 255, 0.7);\n  cursor: pointer;\n  border-left: 3px solid transparent;\n  text-decoration: none;\n  transition:\n    background 0.15s,\n    color 0.15s;\n}\n\n.menuItem:hover {\n  background: rgba(255, 255, 255, 0.07);\n  color: #fff;\n}\n\n.menuItemActive {\n  background: rgba(45, 184, 153, 0.15);\n  border-left-color: #2db899;\n  color: #fff;\n  font-weight: 600;\n}\n\n/* Botón cerrar sesión */\n.sidebarBottom {\n  padding: 20px;\n}\n\n.btnLogout {\n  width: 100%;\n  padding: 10px;\n  background: transparent;\n  border: 1.5px solid rgba(255, 255, 255, 0.2);\n  border-radius: 8px;\n  color: rgba(255, 255, 255, 0.6);\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition:\n    border-color 0.2s,\n    color 0.2s;\n}\n\n.btnLogout:hover {\n  border-color: #fda29b;\n  color: #fda29b;\n}\n\n/* ══════════════════════════════════════\n   CONTENIDO PRINCIPAL\n══════════════════════════════════════ */\n.main {\n  flex: 1;\n  padding: 32px 28px;\n  overflow-y: auto;\n}\n\n/* Cabecera del panel */\n.mainHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 24px;\n}\n\n.mainHeaderLeft p {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  color: #2db899;\n  margin-bottom: 2px;\n}\n\n.mainHeaderLeft h1 {\n  font-size: 1.8rem;\n  font-weight: 800;\n  color: #1a3a5c;\n  margin: 0;\n}\n\n.mainHeaderRight {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n\n.bellBtn {\n  background: #fff;\n  border: 1.5px solid #e4e7ec;\n  border-radius: 50%;\n  width: 38px;\n  height: 38px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: #667085;\n}\n\n.headerAvatar {\n  width: 38px;\n  height: 38px;\n  border-radius: 50%;\n  background: #2db899;\n  color: #fff;\n  font-size: 13px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* ══ Banner bienvenida ══ */\n.welcomeBanner {\n  background: linear-gradient(135deg, #1a3a5c 0%, #1a6b5c 100%);\n  border-radius: 14px;\n  padding: 24px 28px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 20px;\n}\n\n.welcomeLeft {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.welcomeAvatar {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background: rgba(45, 184, 153, 0.35);\n  color: #fff;\n  font-size: 1rem;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.welcomeEyebrow {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  color: rgba(255, 255, 255, 0.6);\n  margin-bottom: 4px;\n}\n\n.welcomeName {\n  font-size: 1.3rem;\n  font-weight: 800;\n  color: #fff;\n  margin-bottom: 2px;\n}\n\n.welcomeDate {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.55);\n}\n\n.welcomeRight {\n  text-align: right;\n}\n\n.profileLabel {\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.6);\n  margin-bottom: 6px;\n}\n\n.profileBar {\n  width: 160px;\n  height: 6px;\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 99px;\n  overflow: hidden;\n  margin-bottom: 6px;\n}\n\n.profileBarFill {\n  height: 100%;\n  background: #2db899;\n  border-radius: 99px;\n}\n\n.profileLink {\n  font-size: 11px;\n  color: #2db899;\n  text-decoration: none;\n  font-weight: 600;\n}\n\n.profileLink:hover {\n  text-decoration: underline;\n}\n\n/* ══ Stats row ══ */\n.statsGrid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 14px;\n  margin-bottom: 20px;\n}\n\n.statCard {\n  background: #fff;\n  border-radius: 12px;\n  padding: 20px 20px 16px;\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06);\n}\n\n.statValue {\n  font-size: 1.8rem;\n  font-weight: 800;\n  color: #1a3a5c;\n  line-height: 1;\n  margin-bottom: 4px;\n}\n\n.statValue.teal {\n  color: #2db899;\n}\n.statValue.orange {\n  color: #f59e0b;\n}\n\n.statTitle {\n  font-size: 13px;\n  font-weight: 600;\n  color: #344054;\n  margin-bottom: 2px;\n}\n\n.statSub {\n  font-size: 11px;\n  color: #98a2b3;\n}\n\n/* ══ Dos columnas ══ */\n.twoCol {\n  display: grid;\n  grid-template-columns: 1fr 300px;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n/* ══ Cards genéricas ══ */\n.card {\n  background: #fff;\n  border-radius: 14px;\n  padding: 22px 22px;\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06);\n}\n\n.cardHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px;\n}\n\n.cardTitle {\n  font-size: 15px;\n  font-weight: 700;\n  color: #1a3a5c;\n  margin: 0;\n}\n\n.cardLink {\n  font-size: 12px;\n  color: #2db899;\n  font-weight: 600;\n  text-decoration: none;\n}\n\n.cardLink:hover {\n  text-decoration: underline;\n}\n\n/* ══ Cita card ══ */\n.citaItem {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 14px 0;\n  border-bottom: 1px solid #f2f4f7;\n}\n\n.citaItem:last-child {\n  border-bottom: none;\n}\n\n.citaAvatar {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: #e6f7f3;\n  color: #2db899;\n  font-size: 12px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.citaInfo {\n  flex: 1;\n}\n\n.citaEspecialidad {\n  font-size: 14px;\n  font-weight: 700;\n  color: #344054;\n  margin-bottom: 2px;\n}\n\n.citaDoctor {\n  font-size: 12px;\n  color: #667085;\n  margin-bottom: 3px;\n}\n\n.citaFecha {\n  font-size: 12px;\n  color: #98a2b3;\n}\n\n.citaMeta {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 6px;\n}\n\n.badgeTele {\n  background: #e6f7f3;\n  color: #2db899;\n  font-size: 10px;\n  font-weight: 700;\n  padding: 3px 8px;\n  border-radius: 999px;\n}\n\n.badgeDomicilio {\n  background: #fff8ec;\n  color: #d97706;\n  font-size: 10px;\n  font-weight: 700;\n  padding: 3px 8px;\n  border-radius: 999px;\n}\n\n.badgePresencial {\n  background: #eff8ff;\n  color: #1a6bcc;\n  font-size: 10px;\n  font-weight: 700;\n  padding: 3px 8px;\n  border-radius: 999px;\n}\n\n.badgeConfirmada {\n  background: #e6f7f3;\n  color: #2db899;\n  font-size: 10px;\n  font-weight: 700;\n  padding: 3px 8px;\n  border-radius: 999px;\n}\n\n.badgePendiente {\n  background: #fff8ec;\n  color: #d97706;\n  font-size: 10px;\n  font-weight: 700;\n  padding: 3px 8px;\n  border-radius: 999px;\n}\n\n.cancelLink {\n  font-size: 11px;\n  color: #98a2b3;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.cancelLink:hover {\n  color: #d92d20;\n}\n\n.emptyState {\n  text-align: center;\n  padding: 24px 0;\n  color: #98a2b3;\n  font-size: 14px;\n}\n\n/* ══ Acciones rápidas ══ */\n.quickActions {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.quickAction {\n  display: flex;\n  flex-direction: column;\n  padding: 12px 14px;\n  border-radius: 10px;\n  border: 1.5px solid #e4e7ec;\n  cursor: pointer;\n  text-decoration: none;\n  transition:\n    border-color 0.15s,\n    background 0.15s;\n  background: #fff;\n}\n\n.quickAction:hover {\n  border-color: #2db899;\n  background: #f0fdf9;\n}\n\n.quickActionPrimary {\n  border-color: #2db899;\n  background: #f0fdf9;\n}\n\n.quickActionTitle {\n  font-size: 13px;\n  font-weight: 700;\n  color: #1a3a5c;\n  margin-bottom: 2px;\n}\n\n.quickActionPrimary .quickActionTitle {\n  color: #2db899;\n}\n\n.quickActionSub {\n  font-size: 11px;\n  color: #98a2b3;\n}\n\n/* ══ Tabla actividad reciente ══ */\n.table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.table thead tr th {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.8px;\n  text-transform: uppercase;\n  color: #98a2b3;\n  padding: 0 10px 12px 0;\n  text-align: left;\n  border-bottom: 1px solid #f2f4f7;\n}\n\n.table tbody tr td {\n  font-size: 13px;\n  color: #344054;\n  padding: 12px 10px 12px 0;\n  border-bottom: 1px solid #f2f4f7;\n  vertical-align: middle;\n}\n\n.table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.badgeCompletada {\n  background: #e6f7f3;\n  color: #2db899;\n  font-size: 10px;\n  font-weight: 700;\n  padding: 3px 8px;\n  border-radius: 999px;\n  white-space: nowrap;\n}\n\n.badgeCancelada {\n  background: #fff1f0;\n  color: #d92d20;\n  font-size: 10px;\n  font-weight: 700;\n  padding: 3px 8px;\n  border-radius: 999px;\n  white-space: nowrap;\n}\n\n/* ══ Dependientes ══ */\n.dependientesGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: 12px;\n}\n\n.dependienteCard {\n  border: 1.5px solid #e4e7ec;\n  border-radius: 10px;\n  padding: 14px 16px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.depAvatar {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: #1a3a5c;\n  color: #fff;\n  font-size: 12px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.depName {\n  font-size: 13px;\n  font-weight: 700;\n  color: #344054;\n  margin-bottom: 2px;\n}\n\n.depMeta {\n  font-size: 11px;\n  color: #98a2b3;\n}\n\n.btnAddDep {\n  border: 1.5px dashed #d0d5dd;\n  border-radius: 10px;\n  padding: 14px 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #2db899;\n  cursor: pointer;\n  background: transparent;\n  text-decoration: none;\n  transition: border-color 0.15s;\n}\n\n.btnAddDep:hover {\n  border-color: #2db899;\n  background: #f0fdf9;\n}\n\n/* ══ Responsive ══ */\n@media (max-width: 900px) {\n  .sidebar {\n    display: none;\n  }\n  .statsGrid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  .twoCol {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 480px) {\n  .statsGrid {\n    grid-template-columns: 1fr 1fr;\n  }\n  .main {\n    padding: 20px 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panelPage": `HistorialUser_panelPage__GVCWR`,
	"sidebar": `HistorialUser_sidebar__cCMHJ`,
	"sidebarTop": `HistorialUser_sidebarTop__DunvU`,
	"avatar": `HistorialUser_avatar__oCdVh`,
	"avatarImg": `HistorialUser_avatarImg__BZeA4`,
	"userName": `HistorialUser_userName__Qt-gG`,
	"userEmail": `HistorialUser_userEmail__4a5bn`,
	"lastConsult": `HistorialUser_lastConsult__j5bX6`,
	"menuLabel": `HistorialUser_menuLabel__LdpbD`,
	"menuList": `HistorialUser_menuList__UGA3Z`,
	"menuItem": `HistorialUser_menuItem__W4Yhg`,
	"menuItemActive": `HistorialUser_menuItemActive__WCR1T`,
	"sidebarBottom": `HistorialUser_sidebarBottom__2lV1a`,
	"btnLogout": `HistorialUser_btnLogout__-EIND`,
	"main": `HistorialUser_main__aFyga`,
	"mainHeader": `HistorialUser_mainHeader__cDtxE`,
	"mainHeaderLeft": `HistorialUser_mainHeaderLeft__zefgY`,
	"mainHeaderRight": `HistorialUser_mainHeaderRight__h9SRO`,
	"bellBtn": `HistorialUser_bellBtn__sI7qf`,
	"headerAvatar": `HistorialUser_headerAvatar__bZIxO`,
	"welcomeBanner": `HistorialUser_welcomeBanner__Jr1D+`,
	"welcomeLeft": `HistorialUser_welcomeLeft__D8nz+`,
	"welcomeAvatar": `HistorialUser_welcomeAvatar__Ep5v4`,
	"welcomeEyebrow": `HistorialUser_welcomeEyebrow__2-uzX`,
	"welcomeName": `HistorialUser_welcomeName__8Kmdk`,
	"welcomeDate": `HistorialUser_welcomeDate__g03zU`,
	"welcomeRight": `HistorialUser_welcomeRight__lKxk-`,
	"profileLabel": `HistorialUser_profileLabel__Q4ktL`,
	"profileBar": `HistorialUser_profileBar__p7aiR`,
	"profileBarFill": `HistorialUser_profileBarFill__-qoAF`,
	"profileLink": `HistorialUser_profileLink__0kNKN`,
	"statsGrid": `HistorialUser_statsGrid__g97fW`,
	"statCard": `HistorialUser_statCard__DwkU0`,
	"statValue": `HistorialUser_statValue__4Zmp8`,
	"teal": `HistorialUser_teal__x66n6`,
	"orange": `HistorialUser_orange__1N8vH`,
	"statTitle": `HistorialUser_statTitle__aJXnK`,
	"statSub": `HistorialUser_statSub__HWQVt`,
	"twoCol": `HistorialUser_twoCol__2Fwpg`,
	"card": `HistorialUser_card__m-zP3`,
	"cardHeader": `HistorialUser_cardHeader__oaPpr`,
	"cardTitle": `HistorialUser_cardTitle__Fa4wp`,
	"cardLink": `HistorialUser_cardLink__+6Spp`,
	"citaItem": `HistorialUser_citaItem__g3jcv`,
	"citaAvatar": `HistorialUser_citaAvatar__TqldI`,
	"citaInfo": `HistorialUser_citaInfo__VAlKZ`,
	"citaEspecialidad": `HistorialUser_citaEspecialidad__0GiI2`,
	"citaDoctor": `HistorialUser_citaDoctor__rLhfJ`,
	"citaFecha": `HistorialUser_citaFecha__xBFso`,
	"citaMeta": `HistorialUser_citaMeta__U7eTM`,
	"badgeTele": `HistorialUser_badgeTele__2XjqO`,
	"badgeDomicilio": `HistorialUser_badgeDomicilio__HVuq-`,
	"badgePresencial": `HistorialUser_badgePresencial__QPoGD`,
	"badgeConfirmada": `HistorialUser_badgeConfirmada__e3njO`,
	"badgePendiente": `HistorialUser_badgePendiente__Ix1d4`,
	"cancelLink": `HistorialUser_cancelLink__4k1KM`,
	"emptyState": `HistorialUser_emptyState__kmfAv`,
	"quickActions": `HistorialUser_quickActions__Ng2x+`,
	"quickAction": `HistorialUser_quickAction__BIMVr`,
	"quickActionPrimary": `HistorialUser_quickActionPrimary__kILpF`,
	"quickActionTitle": `HistorialUser_quickActionTitle__2DNaJ`,
	"quickActionSub": `HistorialUser_quickActionSub__rfTgK`,
	"table": `HistorialUser_table__6zJXl`,
	"badgeCompletada": `HistorialUser_badgeCompletada__GFkor`,
	"badgeCancelada": `HistorialUser_badgeCancelada__gnOwf`,
	"dependientesGrid": `HistorialUser_dependientesGrid__h3F25`,
	"dependienteCard": `HistorialUser_dependienteCard__gG4TL`,
	"depAvatar": `HistorialUser_depAvatar__IaUAD`,
	"depName": `HistorialUser_depName__YqCwl`,
	"depMeta": `HistorialUser_depMeta__lETFU`,
	"btnAddDep": `HistorialUser_btnAddDep__MOhlo`
};
export default ___CSS_LOADER_EXPORT___;
